import { BrandSettings } from '@weave/schema-gen-ts/dist/schemas/brand-settings/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaBrandSettingsService = bindHTTP(BrandSettings);
